export default __webpack_public_path__ + "static/media/Hokky1fsfr.aafe0ee5.gif";